import authorProfile from '../../widgets/general/author-profile'
import authorArticles from '../../widgets/general/author-articles'

const createAuthorLayoutWidgets = () => [authorProfile(), authorArticles()]

export default createAuthorLayoutWidgets
